import React, { useEffect } from 'react';
import Data from '../../Data/Data.json'
import { Button, Form, Space, Typography } from 'antd';
import Table from '../TableResizable';
import { useNavigate } from 'react-router-dom';
import PageNotFound from '../../Pages/PageNotFound';
import formatNumber from '../../Functions/Traitement/FormatNumber';
import { Backpack, Backspace, BackspaceSharp, Print } from '@mui/icons-material';
import { Backdrop, Box } from '@mui/material';
import { useAuthUser } from '../../Services/Auth/sessionAuth';
import Utilisateur from '../../Models/Utilisateur';
import Logo from "../../Res/greenLogo.png"
import i18next from 'i18next';

const PrintClotureSystemCaisse = () => {
    const [tab, setTab] = React.useState(localStorage.getItem(Data.LocalVariable.tabCaisse) ? JSON.parse(localStorage.getItem(Data.LocalVariable.tabCaisse) + "") : null as any)
    const navigate = useNavigate();
    // USER SESSION
    const auth = useAuthUser();
    const user: Utilisateur = JSON.parse(JSON.stringify(auth()))

    useEffect(() => {
        //alert(JSON.stringify(tab?.form))
        if (tab == null) {
            navigate("/systemecaisse/fermeture")
        }
    })
    return (
        <div><br />
            {tab ?
                <>
                    <Box className='backBtnt' onClick={() => { navigate(-1) }}><Backspace /></Box>
                    <Box marginLeft={"6%"} className={"preview_print"}>
                        <Box className={"title"} display={"flex"} fontStyle={"inherit"}>
                            <img className='printLogo' src={Logo} width={80} />

                            <Typography className='textTitle1' ><b>{tab?.form?.titre}</b></Typography>

                            <hr className='hide' />
                            <Button title='Imprimer ( ctrl + p )' onClick={() => { window.print() }} icon={<Print />} size='large' className='bt_add' type="ghost" htmlType="button" block  ></Button>
                        </Box><br />
                        <Box display={"flex"} fontStyle="inherit">
                            <Box width={"40%"}>
                                <Box width={"120%"} display={"flex"}><Typography>Agence : </Typography><Typography className='textRight1'><b>{user.codage}</b></Typography></Box>
                                <Box width={"120%"} display={"flex"}><Typography>Date : </Typography><Typography className='textRight1'><b>{user.datjour}</b></Typography></Box>
                                <hr />
                            </Box><hr />
                            <Box width={"50%"}>
                                <Box className='haut' width={"120%"} display={"flex"}><Typography className='textRight1'>{"Imprimé par " + user.coduti + " - " + user.nomuti + " le " + (new Date(Date.now())).toLocaleDateString(i18next.language) + " à " + (new Date(Date.now())).toLocaleTimeString(i18next.language)}</Typography></Box><br />
                            </Box>
                        </Box><br />
                        <Table size='small' showHeader bordered={true} pagination={false} columns={tab?.columns} dataSource={tab?.data} />
                        <br />
                        {/* {(tab?.form?.UTIVAL  != undefined && tab?.form?.UTIVAL != "")?<Box width={"120%"}  display={"flex"}><Typography>Dossier de crédit validé par : </Typography><Typography className='textRight1'><b>{(tab?.form?.UTIVAL)}</b></Typography></Box> : ""} */}



                        <Box fontStyle={"inherit"} display={"flex"}>
                            <Box>
                                <Typography style={{ textAlign: "center" }}>Signature Caissier(ière)</Typography>
                                <Box style={{ border: "1px rgba(0, 0, 0, .1) solid", backgroundColor: 'rgba(0, 0, 0, .05', width: '350px', height: "50px", borderRadius: "5px" }}></Box>
                            </Box>
                            <hr />
                            <Box>
                                <Typography style={{ textAlign: "center" }}>Signature Controlleur</Typography>
                                <Box style={{ border: "1px rgba(0, 0, 0, .1) solid", backgroundColor: 'rgba(0, 0, 0, .05', width: '350px', height: "50px", borderRadius: "5px" }}></Box>
                            </Box>
                        </Box>
                    </Box>

                </>
                :
                <PageNotFound message={"Nothing to print"} backLink={"/systemecaisse/fermeture"} texttButton={"Back"} />}
        </div>
    );
};

export default PrintClotureSystemCaisse;